<template>

       <div>
                   <div class="menuTop">
                      <span v-for="(list,i) in filterLists" :key="i" v-if="list.value&&i!=0" >
                        {{list.text}}
                          <img @click="del1(i,list.type)" src="@/assets/img/salary/del.png"/>
                      </span>
                    
                  </div>
                  <div class="menuCon">
                      <p>温馨提示：填写之后自动展示控件，可自定义删除。{{load1}}</p>
                      <el-form class="form form1" :model="filterLists" label-width="80px">
                        <el-form-item v-for="(list,i) in filterLists" v-if="i!=0" :label="list.text+'：'" :key="list" style="height:40px;">
                          <el-input v-if="list.type=='text'" v-model.trim="list.value" style="width:170px;" placeholder="请输入"></el-input>
                            <el-select v-if="list.type=='select'||list.type=='radio'" v-model="list.value" :multiple="list.multiple"  placeholder="请选择" style="width:170px;">
                              <el-option
                                v-for="item in list.options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select>
                              <el-date-picker v-if="list.type=='timer'" style="width:170px;"
                                v-model="list.value"
                                type="date"
                                placeholder="选择日期">
                              </el-date-picker>
															
															<CiicTreeSelect  style="width:170px;" ref="mychild" v-if="list.type=='treeSelect'&&list.options.length>0" :options="list.options" @getValue="selectGroup"
															:props="defaultGroupProps" :value="list.value" :multiple="list.multiple"  :expand="true" :showFilter="false"></CiicTreeSelect>
                            <!-- <el-radio v-if="list.type=='radio'" v-model="list.value" v-for="item in list.options" :label="item.value">{{item.label}}</el-radio> -->

                        </el-form-item>
                      </el-form>
                  </div>
                  <div class="flex">
                        <el-button type="primary" @click="save(false)">取消</el-button>
                        <el-button type="primary" @click="save(true)">确定</el-button>
                  </div>
              </div>
      
</template>

<script>
  import CiicTreeSelect from "@/components/ciic/ciic-tree-select/ciic-tree-select";

  export default {
    name: "sbs-filter-box",
		components: {
			CiicTreeSelect
		},
    props: {
        filterLists: {
            type: Array,
            default: [],
        }
    },
    data() {
      return {
          show:true,
					defaultGroupProps: {
					children: 'children',
					label: 'label',
					value: 'value',
					
					},
					load1:true
      };
    },
    methods: {
				selectGroup(val,title,name){
					for(var i=0;i<this.filterLists.length;i++){
						if(this.filterLists[i].name==name){
							this.filterLists[index].value=val;
						}
					}
					console.log(this.filterLists)
					this.$emit('update:filterList2',this.filterLists);
					
				},
        save(save){
            this.$emit('isSave',save);
        },
        del1(index,type){
						this.filterLists[index].value="";
            if(type == 'treeSelect'){
							console.log(this.$refs.mychild)
							 this.$refs.mychild[0].clearHandle();
            }
        }
    }
  };
</script>

<style scoped >
.flex{
    display:flex;
    justify-content: space-between;
    padding:22px 20px 8px;
}
     .menuTop{
          border-bottom: 4px solid #eee;
          padding:0 20px;
    }
    .menuTop span{
      padding:0 6px;
      background:rgba(238,238,238,1);
      border-radius:2px;
      display:inline-block;
      height:34px;
      line-height:34px;
      margin-right:15px;
      color:rgba(51,51,51,1);
      font-size:13px;
      font-weight:500;
      margin-bottom:15px;
      position:relative;
    }
    .menuTop span img{
        position:absolute;
        right:-6px;
        top:-6px;
        cursor: pointer;
    }
     .menuCon{
       padding:0 20px;
     }
    .menuCon p{
        font-size:12px;
        font-weight:400;
        color:rgba(252,106,106,1);
        line-height:17px;
        padding-top:10px;
        padding-bottom: 8px;
    }
    .form1 .el-form-item{
      margin-bottom:8px;
    }
</style>
